import {AddCallPage} from './../add-call/add-call';
import {CallDetailPage} from './../call-detail/call-detail';
import {CallsProvider} from './../../providers/api/calls.provider';
import {Component} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  ActionSheetButton,
  ActionSheetController, AlertController
} from 'ionic-angular';
import {Call, CallStatus, Deal, DealStatus, DealStatusDescriptions, Operator} from '../../models/models';
import {SettingsProvider} from '../../providers/settings/settings';
import {ContactListPage} from '../contact-list/contact-list';
import {tap} from "rxjs/operators";
import {ContactProvider} from "../../providers/api/contacts.provider";
import {ApiProvider} from "../../providers/api/api";
import {OperatorProvider} from "../../providers/operator/operator";

@IonicPage()
@Component({
  selector: 'page-calls',
  templateUrl: 'calls.html',
})
export class CallsPage {

  tab = 'PLANNED'

  callsPlanned: Call[] = []
  callsDone: Call[] = []

  nextDoneUrl: string
  nextPlannedeUrl: string

  CallStatus = CallStatus
  operator: Operator
  isLoading = false

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public settings: SettingsProvider,
    private operatorProvider: OperatorProvider,
    private api: ApiProvider,
    private alertCtrl: AlertController,
    private contactProvider: ContactProvider,
    private readonly callsProvider: CallsProvider,
    private readonly actionSheetController: ActionSheetController) {
    this.operatorProvider.currentOperator.subscribe(operator => {
      this.operator = operator
      this.refresh()
    })
    this.getData()
  }

  reset() {
    this.callsPlanned = []
    this.callsDone = []
    this.nextPlannedeUrl = ""
    this.nextDoneUrl = ""
  }

  getData() {
    this.isLoading = true
    this.callsProvider.getCalls(false).subscribe(calls => {
      this.callsPlanned = calls.results
      this.nextPlannedeUrl = calls.next
      this.isLoading = false
    })

    this.callsProvider.getCalls(true).subscribe(calls => {
      this.callsDone = calls.results
      this.nextDoneUrl = calls.next
      this.isLoading = false
    })
  }

  refresh() {
    this.reset()
    this.getData()
  }

  open(call) {
    this.navCtrl.push(CallDetailPage, {
      call: call,
      parent: this
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CallsPage');
  }

  selectDeal(deals: Deal[], selectionHandler: (deal: Deal, create: boolean, product_id: number) => void) {

    let myp_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_MYP)
    let social_deal = deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_SOCIAL)

    let choices = deals.map(
      deal => {
        return {
          text: `${deal.product.name} (${DealStatusDescriptions[deal.status]})`,
          handler: () => {
            selectionHandler(deal, false, null)
          }
        }
      })
    if (!myp_deal) {
      choices.push({
        text: `${this.settings.PRODUCT_MYP}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_MYP_ID)
        }
      })
    }
    if (!social_deal) {
      choices.push({
        text: `${this.settings.PRODUCT_SOCIAL}`,
        handler: () => {
          selectionHandler(null, true, this.settings.PRODUCT_SOCIAL_ID)
        }
      })
    }

    let buttons: ActionSheetButton[] = choices

    buttons.push({
      text: 'Annulla',
      icon: 'close',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    })

    const actionSheet = this.actionSheetController.create({
      title: 'Seleziona Deal',
      buttons: buttons
    });
    actionSheet.present();
  }

  addCall() {
    let contactModal = this.modalCtrl.create(ContactListPage, {modal: true});
    contactModal.onDidDismiss(contact => {
      if (contact != null) {

        let deals = contact.deals.filter(deal => deal.status == DealStatus.OPEN && this.settings.PRODUCTS.some(p => p == (deal.product && deal.product.ac_label)))

        this.selectDeal(deals, (deal, create, product_id) => {
          if (create) {
            let product_label = product_id == this.settings.PRODUCT_SOCIAL_ID ? this.settings.PRODUCT_SOCIAL : this.settings.PRODUCT_MYP

            return this.api.postDeal(
              contact.id,
              product_id,
              this.settings.PIPELINE_VENDITA_BY_PRODUCT[product_label],
              this.settings.STAGE_APPOINTMENT_TODO_BY_PRODUCT[product_label],
              this.operator.id
            ).pipe(tap(
              _ => {
                this.contactProvider.pushOnAC(contact.id).subscribe(_ => {
                })
              }
            )).subscribe(deal => {
              let callModal = this.modalCtrl.create(AddCallPage, {
                contact: contact,
                deal: deal
              }, {showBackdrop: true})
              callModal.onDidDismiss(_value => {
              })
              callModal.present()
            }, e => {
              this.alertCtrl.create({
                title: "Anomalia",
                message: "Si è verificato un errore",
                buttons: [
                  {
                    text: 'Ok',
                    handler: () => {
                    }
                  },
                ]
              }).present()
              console.log(e)
            })

          } else {
            let callModal = this.modalCtrl.create(AddCallPage, {
              contact: contact,
              deal: deal
            }, {showBackdrop: true})
            callModal.onDidDismiss(_value => {
            })
            callModal.present()
          }

        })

      }
    });
    contactModal.present();
  }

  nextDone(event) {
    if (!this.nextDoneUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.callsProvider.getNextCalls(this.nextDoneUrl).subscribe(
      page => {
        this.callsDone.push(...page.results)
        this.nextDoneUrl = page.next
      },
      e => {
        console.log(e)
      },
      () => {
        if (event !== null) event.complete()
      }
    )
  }

  nextPlanned(event) {
    if (!this.nextPlannedeUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.callsProvider.getNextCalls(this.nextPlannedeUrl).subscribe(
      page => {
        this.callsPlanned.push(...page.results)
        this.nextPlannedeUrl = page.next
      },
      e => {
        console.log(e)
      },
      () => {
        if (event !== null) event.complete()
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/calls/calls.ts